// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3F8np","countryTitle":"Card_countryTitle__143vd","closeIcon":"Card_closeIcon__3M7kP","card-body":"Card_card-body__1vsqg"};